import React from 'react'
import PublisherForm from './components/PublisherForm'

const FormView = () => {
  return (
    <>
      <div className='flex flex-wrap flex-1 min-h-full'>
        <div className='p-6 flex-1'>
          <PublisherForm />
        </div>
      </div>
    </>
  )
}

export default FormView
